module.exports = __webpack_public_path__ + "img/venezuela.6c3e6f63.svg";